function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "transparent",
  x: 0.109,
  width: 283.464,
  height: 283.465
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M261.554,76.729l-74.477,10.29l13.121,16.873c-25.971,20.218-45.805,46.098-58.357,75.244 c-12.553-29.146-32.386-55.026-58.357-75.244L96.606,87.02l-74.477-10.29l28.32,69.641l13.991-17.99 c38.735,30.16,61.194,75.332,61.891,124.252c-0.009,0.781-0.033,1.561-0.033,2.344v25.543h0.066h30.956h0.066v-25.543 c0-0.783-0.025-1.562-0.033-2.344c0.695-48.92,23.154-94.092,61.891-124.252l13.99,17.99L261.554,76.729z"
});

function SvgVlja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.46px",
    height: "283.46px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlja);
export default __webpack_public_path__ + "static/media/välja.bc2e6a75.svg";
export { ForwardRef as ReactComponent };